// Search words for what an icon's drawing shows, where neither its name nor
// MDI's aliases say so: white-balance-incandescent is a lightbulb, nature is a
// tree.  Checked against the rendered 3.5.95 drawings.  Keys are 3.5.95 names;
// search treats these words like MDI's aliases.

export const iconAliases: Record<string, string[]> = {
  'access-point': ['broadcast', 'signal', 'radio'],
  'account-tie': ['suit', 'business', 'man'],
  adjust: ['dot', 'target', 'circle'],
  airport: ['tower'],
  'alarm-light': ['siren'],
  'alarm-light-outline': ['siren'],
  album: ['cd', 'disc'],
  alert: ['exclamation', 'triangle'],
  'alert-circle': ['exclamation'],
  'alert-circle-outline': ['exclamation'],
  'alert-octagon': ['exclamation'],
  'alert-octagon-outline': ['exclamation'],
  'alert-outline': ['exclamation', 'triangle'],
  alpha: ['greek'],
  amplifier: ['speaker'],
  apps: ['grid', 'squares'],
  'arrow-all': ['move'],
  'arrow-decision': ['choice', 'branch', 'fork'],
  'arrow-decision-auto': ['choice', 'branch'],
  'arrow-decision-auto-outline': ['choice', 'branch'],
  'arrow-decision-outline': ['choice', 'branch', 'fork'],
  artist: ['singer', 'musician'],
  'artist-outline': ['singer', 'musician'],
  assistant: ['sparkle', 'star'],
  attachment: ['clip'],
  'auto-fix': ['sparkle'],
  autorenew: ['refresh', 'cycle', 'repeat'],
  'av-timer': ['clock'],
  ballot: ['checklist', 'list'],
  'ballot-outline': ['checklist', 'list'],
  bandage: ['injury'],
  bank: ['building', 'columns'],
  beach: ['umbrella', 'sun'],
  'block-helper': ['no', 'forbidden', 'prohibited', 'ban', 'circle'],
  bolt: ['screw'],
  boombox: ['radio', 'stereo', 'cassette'],
  'border-color': ['pencil'],
  bowling: ['ball'],
  'bread-slice': ['toast'],
  'bread-slice-outline': ['toast'],
  briefcase: ['bag', 'suitcase'],
  'briefcase-outline': ['bag', 'suitcase'],
  'brightness-1': ['circle', 'dot'],
  'brightness-2': ['moon', 'night', 'crescent'],
  'brightness-3': ['moon', 'night', 'crescent'],
  'brightness-4': ['sun'],
  'brightness-5': ['sun'],
  'brightness-6': ['sun'],
  'brightness-7': ['sun'],
  broom: ['sweep', 'clean'],
  bug: ['insect', 'beetle'],
  'bug-outline': ['insect', 'beetle'],
  bugle: ['trumpet'],
  'bulletin-board': ['poster'],
  bullhorn: ['speaker'],
  'bullhorn-outline': ['speaker'],
  'bullseye-arrow': ['dart'],
  cached: ['refresh', 'cycle', 'repeat'],
  cactus: ['desert', 'plant'],
  'camera-image': ['picture'],
  'camera-iris': ['aperture', 'shutter'],
  'camera-timer': ['stopwatch'],
  cancel: ['forbidden', 'circle'],
  candycane: ['christmas'],
  caravan: ['trailer', 'camper'],
  cards: ['playing cards'],
  carrot: ['vegetable'],
  cash: ['dollar', 'bill'],
  'cash-100': ['bill'],
  'cash-multiple': ['bill'],
  'cash-register': ['store'],
  certificate: ['award'],
  'chair-school': ['classroom'],
  charity: ['hands', 'heart'],
  'chart-bar': ['statistics'],
  'chart-bell-curve': ['statistics'],
  'chart-histogram': ['statistics'],
  'chart-line-variant': ['trend'],
  chat: ['speech', 'talk'],
  'chat-processing': ['speech', 'bubble', 'talk'],
  'check-circle': ['done'],
  'check-circle-outline': ['done'],
  'check-decagram': ['badge'],
  'checkbox-blank': ['square'],
  'checkbox-blank-circle': ['dot'],
  'checkbox-blank-outline': ['square'],
  'checkbox-marked': ['tick'],
  'checkbox-marked-circle': ['tick'],
  'checkbox-marked-circle-outline': ['tick'],
  checkerboard: ['chess', 'board'],
  'chef-hat': ['cooking', 'kitchen'],
  chip: ['processor', 'computer'],
  'circle-slice-1': ['pie', 'fraction'],
  'circle-slice-2': ['pie', 'fraction'],
  'circle-slice-3': ['pie', 'fraction'],
  'circle-slice-4': ['pie', 'fraction'],
  'circle-slice-5': ['pie', 'fraction'],
  'circle-slice-6': ['pie', 'fraction'],
  'circle-slice-7': ['pie', 'fraction'],
  'circle-slice-8': ['pie', 'fraction'],
  city: ['buildings', 'town'],
  'city-variant': ['buildings', 'town'],
  'clipboard-pulse': ['heartbeat', 'health'],
  'clipboard-pulse-outline': ['heartbeat', 'health'],
  clippy: ['paperclip'],
  close: ['x', 'cross'],
  'close-circle': ['x', 'cross'],
  'close-circle-outline': ['x', 'cross'],
  clover: ['shamrock', 'four leaf'],
  coffee: ['mug'],
  'coffee-outline': ['mug'],
  'coffee-to-go': ['takeaway'],
  cogs: ['gears', 'machine'],
  coins: ['money'],
  comment: ['speech', 'bubble', 'talk'],
  'comment-multiple': ['conversation', 'discussion', 'speech'],
  'comment-multiple-outline': ['conversation', 'discussion', 'speech'],
  'comment-outline': ['speech', 'bubble', 'talk'],
  'comment-processing': ['speech', 'typing'],
  'comment-processing-outline': ['speech', 'typing'],
  'comment-text': ['speech', 'message'],
  'comment-text-multiple': ['conversation', 'discussion'],
  'comment-text-multiple-outline': ['conversation', 'discussion'],
  'comment-text-outline': ['speech', 'message'],
  console: ['code', 'computer'],
  contacts: ['address book', 'person'],
  'content-paste': ['clipboard'],
  'controller-classic': ['video game'],
  'controller-classic-outline': ['video game'],
  corn: ['maize', 'vegetable'],
  counter: ['scoreboard'],
  crane: ['construction'],
  cricket: ['ball'],
  crosshairs: ['target', 'aim'],
  'crosshairs-gps': ['target', 'aim'],
  cube: ['box', '3d'],
  'cube-outline': ['box', '3d'],
  cupcake: ['muffin', 'cake'],
  curling: ['stone'],
  'currency-cny': ['money'],
  'currency-eur': ['money'],
  'currency-gbp': ['money'],
  'currency-inr': ['money'],
  'currency-jpy': ['money'],
  'currency-krw': ['money'],
  'cursor-pointer': ['finger', 'click'],
  decagram: ['badge'],
  'decagram-outline': ['badge'],
  delta: ['triangle'],
  'desk-lamp': ['light'],
  'desktop-tower': ['computer'],
  'desktop-tower-monitor': ['computer'],
  diamond: ['gem', 'jewel'],
  'diamond-outline': ['gem', 'jewel'],
  'diamond-stone': ['gem'],
  'dice-multiple': ['game'],
  directions: ['road', 'sign'],
  dns: ['server'],
  domain: ['office'],
  'drama-masks': ['theater', 'acting'],
  drawing: ['shapes'],
  email: ['letter'],
  'email-open': ['mail', 'letter'],
  'email-open-outline': ['mail', 'letter'],
  'email-outline': ['letter'],
  emoticon: ['feeling', 'emotion', 'happy'],
  'emoticon-angry': ['feeling', 'emotion', 'mad', 'upset'],
  'emoticon-angry-outline': ['feeling', 'emotion', 'mad', 'upset'],
  'emoticon-cool': ['feeling', 'emotion'],
  'emoticon-cool-outline': ['feeling', 'emotion'],
  'emoticon-cry': ['feeling', 'emotion', 'sad', 'tears', 'upset'],
  'emoticon-cry-outline': ['feeling', 'emotion', 'sad', 'tears', 'upset'],
  'emoticon-dead': ['feeling', 'emotion'],
  'emoticon-dead-outline': ['feeling', 'emotion'],
  'emoticon-devil': ['feeling', 'emotion'],
  'emoticon-devil-outline': ['feeling', 'emotion'],
  'emoticon-excited': ['feeling', 'emotion', 'happy', 'joy'],
  'emoticon-excited-outline': ['feeling', 'emotion', 'happy', 'joy'],
  'emoticon-happy': ['feeling', 'emotion'],
  'emoticon-happy-outline': ['feeling', 'emotion'],
  'emoticon-kiss': ['feeling', 'emotion'],
  'emoticon-kiss-outline': ['feeling', 'emotion'],
  'emoticon-neutral': ['feeling', 'emotion', 'meh', 'okay'],
  'emoticon-neutral-outline': ['feeling', 'emotion', 'meh', 'okay'],
  'emoticon-outline': ['feeling', 'emotion', 'happy'],
  'emoticon-poop': ['feeling', 'emotion'],
  'emoticon-poop-outline': ['feeling', 'emotion', 'smiley'],
  'emoticon-sad': ['feeling', 'emotion', 'unhappy', 'upset'],
  'emoticon-sad-outline': ['feeling', 'emotion', 'unhappy', 'upset'],
  'emoticon-tongue': ['feeling', 'emotion', 'silly', 'playful'],
  'emoticon-tongue-outline': ['feeling', 'emotion', 'silly', 'playful'],
  'emoticon-wink': ['feeling', 'emotion'],
  'emoticon-wink-outline': ['feeling', 'emotion'],
  eraser: ['rubber'],
  'eraser-variant': ['rubber'],
  'exit-run': ['running'],
  eyedropper: ['dropper'],
  'eyedropper-variant': ['dropper'],
  face: ['boy', 'child', 'kid', 'person'],
  'face-agent': ['headset', 'helper'],
  'face-outline': ['boy', 'child', 'kid', 'person'],
  'face-profile': ['person', 'child'],
  factory: ['industry', 'building'],
  feather: ['pen', 'bird'],
  'file-cabinet': ['drawer'],
  'file-document': ['paper', 'page'],
  'file-document-box': ['paper', 'page'],
  'file-document-outline': ['paper', 'page'],
  'file-image': ['picture', 'photo'],
  fingerprint: ['identity', 'unique', 'touch'],
  fire: ['burn', 'campfire'],
  'flag-checkered': ['finish', 'race'],
  flare: ['sun', 'sparkle'],
  'floor-plan': ['map', 'house', 'rooms'],
  floppy: ['disk', 'save'],
  'food-apple': ['fruit'],
  'food-apple-outline': ['fruit'],
  'food-fork-drink': ['restaurant', 'eat', 'meal', 'cutlery', 'lunch'],
  football: ['rugby', 'ball'],
  'football-australian': ['rugby', 'ball'],
  'format-list-checkbox': ['checklist', 'todo'],
  'format-list-checks': ['checklist', 'todo', 'tasks'],
  'format-list-numbered': ['steps'],
  'format-paint': ['roller'],
  'format-quote-close': ['quotation'],
  'format-quote-open': ['quotation'],
  forum: ['talk', 'speech'],
  'forum-outline': ['talk', 'speech'],
  'fountain-pen': ['ink'],
  'fountain-pen-tip': ['ink'],
  fuel: ['jerrycan'],
  'gamepad-variant': ['video game'],
  gate: ['fence'],
  gauge: ['speedometer', 'meter', 'dial'],
  'gauge-empty': ['speedometer', 'meter', 'dial'],
  'gauge-full': ['speedometer', 'meter', 'dial'],
  'gauge-low': ['speedometer', 'meter', 'dial'],
  'gesture-double-tap': ['finger', 'touch'],
  'gesture-swipe': ['finger', 'hand'],
  'gesture-tap': ['finger'],
  ghost: ['halloween', 'spooky'],
  glasses: ['spectacles', 'eyeglasses', 'reading'],
  'globe-model': ['earth', 'world'],
  'go-kart': ['race'],
  golf: ['flag', 'hole'],
  'grease-pencil': ['marker'],
  'guitar-acoustic': ['instrument'],
  'guitar-electric': ['instrument'],
  hail: ['raise hand', 'person'],
  hamburger: ['sandwich'],
  hammer: ['build'],
  'hand-peace': ['victory'],
  'hand-peace-variant': ['victory'],
  'hand-pointing-down': ['finger'],
  'hand-pointing-left': ['finger'],
  'hand-pointing-right': ['finger'],
  'hand-pointing-up': ['finger'],
  'hard-hat': ['construction', 'safety'],
  'hazard-lights': ['triangle'],
  headset: ['headphones', 'microphone', 'call'],
  'heart-broken': ['sad', 'heartbreak'],
  'heart-broken-outline': ['sad', 'heartbreak'],
  'heart-pulse': ['heartbeat', 'health'],
  hexagram: ['star of david'],
  'hexagram-outline': ['star of david'],
  hiking: ['walk', 'hiker'],
  history: ['past'],
  'home-group': ['houses', 'neighborhood', 'community'],
  'home-modern': ['building'],
  hook: ['fishing'],
  hotel: ['sleep'],
  human: ['person', 'body'],
  'human-female': ['girl', 'person'],
  'human-female-boy': ['parent'],
  'human-female-girl': ['parent'],
  'human-handsdown': ['person'],
  'human-handsup': ['person'],
  'human-male': ['boy', 'person'],
  'human-male-boy': ['parent'],
  'human-male-female': ['couple'],
  'human-male-girl': ['parent'],
  'ice-cream': ['dessert', 'cone'],
  image: ['picture'],
  'image-filter-hdr': ['mountains'],
  'image-filter-vintage': ['flower'],
  'image-outline': ['picture', 'photo'],
  inbox: ['tray'],
  incognito: ['secret', 'detective', 'disguise'],
  'invert-colors': ['drop', 'water'],
  ipod: ['music player'],
  islam: ['moon'],
  kabaddi: ['tag'],
  keyboard: ['typing'],
  label: ['tag'],
  'label-outline': ['tag'],
  ladybug: ['insect'],
  lamp: ['light'],
  layers: ['stack'],
  leaf: ['plant'],
  'leaf-maple': ['canada', 'autumn', 'fall'],
  library: ['book', 'person reading'],
  'library-shelves': ['books'],
  lifebuoy: ['lifesaver', 'ring'],
  link: ['chain'],
  'link-variant': ['chain'],
  lock: ['padlock'],
  'lock-open': ['padlock'],
  'lock-open-outline': ['padlock'],
  'lock-outline': ['padlock'],
  looks: ['arc'],
  magnify: ['magnifying glass', 'zoom'],
  mailbox: ['post'],
  'map-marker': ['pin'],
  'map-marker-outline': ['pin'],
  marker: ['pen'],
  'marker-check': ['badge', 'verified'],
  'math-compass': ['geometry'],
  'medical-bag': ['doctor'],
  memory: ['processor'],
  message: ['speech'],
  'message-outline': ['speech'],
  'message-processing': ['typing', 'chat', 'speech'],
  'message-text': ['speech', 'bubble'],
  'message-text-outline': ['speech', 'bubble', 'chat'],
  metronome: ['rhythm'],
  'microphone-variant': ['karaoke'],
  monitor: ['screen', 'computer'],
  'mother-nurse': ['breastfeeding', 'baby'],
  'motion-sensor': ['walking', 'person'],
  motorbike: ['scooter'],
  mouse: ['computer'],
  muffin: ['cupcake'],
  music: ['note', 'song'],
  'music-box': ['note', 'song'],
  'music-circle': ['song'],
  'music-note': ['song'],
  nature: ['tree'],
  'nature-people': ['tree', 'park', 'person'],
  navigation: ['direction'],
  needle: ['vaccine'],
  note: ['page'],
  'note-outline': ['page'],
  'numeric-0': ['digit'],
  'numeric-0-box': ['digit'],
  'numeric-0-box-multiple-outline': ['digit'],
  'numeric-0-box-outline': ['digit'],
  'numeric-0-circle': ['digit'],
  'numeric-0-circle-outline': ['digit'],
  'numeric-1': ['digit'],
  'numeric-1-box': ['digit'],
  'numeric-1-box-multiple-outline': ['digit'],
  'numeric-1-box-outline': ['digit'],
  'numeric-1-circle': ['digit'],
  'numeric-1-circle-outline': ['digit'],
  'numeric-2': ['digit'],
  'numeric-2-box': ['digit'],
  'numeric-2-box-multiple-outline': ['digit'],
  'numeric-2-box-outline': ['digit'],
  'numeric-2-circle': ['digit'],
  'numeric-2-circle-outline': ['digit'],
  'numeric-3': ['digit'],
  'numeric-3-box': ['digit'],
  'numeric-3-box-multiple-outline': ['digit'],
  'numeric-3-box-outline': ['digit'],
  'numeric-3-circle': ['digit'],
  'numeric-3-circle-outline': ['digit'],
  'numeric-4': ['digit'],
  'numeric-4-box': ['digit'],
  'numeric-4-box-multiple-outline': ['digit'],
  'numeric-4-box-outline': ['digit'],
  'numeric-4-circle': ['digit'],
  'numeric-4-circle-outline': ['digit'],
  'numeric-5': ['digit'],
  'numeric-5-box': ['digit'],
  'numeric-5-box-multiple-outline': ['digit'],
  'numeric-5-box-outline': ['digit'],
  'numeric-5-circle': ['digit'],
  'numeric-5-circle-outline': ['digit'],
  'numeric-6': ['digit'],
  'numeric-6-box': ['digit'],
  'numeric-6-box-multiple-outline': ['digit'],
  'numeric-6-box-outline': ['digit'],
  'numeric-6-circle': ['digit'],
  'numeric-6-circle-outline': ['digit'],
  'numeric-7': ['digit'],
  'numeric-7-box': ['digit'],
  'numeric-7-box-multiple-outline': ['digit'],
  'numeric-7-box-outline': ['digit'],
  'numeric-7-circle': ['digit'],
  'numeric-7-circle-outline': ['digit'],
  'numeric-8': ['digit'],
  'numeric-8-box': ['digit'],
  'numeric-8-box-multiple-outline': ['digit'],
  'numeric-8-box-outline': ['digit'],
  'numeric-8-circle': ['digit'],
  'numeric-8-circle-outline': ['digit'],
  'numeric-9': ['digit'],
  'numeric-9-box': ['digit'],
  'numeric-9-box-multiple-outline': ['digit'],
  'numeric-9-box-outline': ['digit'],
  'numeric-9-circle': ['digit'],
  'numeric-9-circle-outline': ['digit'],
  'numeric-9-plus-box': ['digit'],
  'numeric-9-plus-box-multiple-outline': ['digit'],
  'numeric-9-plus-box-outline': ['digit'],
  'numeric-9-plus-circle': ['digit'],
  'numeric-9-plus-circle-outline': ['digit'],
  oar: ['paddle', 'rowing'],
  ocarina: ['flute', 'instrument'],
  'one-up': ['mushroom'],
  opacity: ['drop'],
  ornament: ['christmas', 'bauble'],
  'ornament-variant': ['christmas', 'bauble'],
  owl: ['bird'],
  'pac-man': ['game'],
  package: ['parcel'],
  'package-variant': ['parcel'],
  'package-variant-closed': ['parcel'],
  palette: ['painting', 'colors'],
  'palette-outline': ['painting', 'colors'],
  'palette-swatch': ['colors'],
  panorama: ['picture', 'landscape'],
  paw: ['dog', 'cat', 'footprint'],
  peace: ['peace sign'],
  'periodic-table': ['chemistry', 'elements'],
  pharmacy: ['medicine'],
  'phone-classic': ['telephone', 'call'],
  piano: ['keyboard', 'instrument'],
  pickaxe: ['mining', 'dig'],
  pin: ['pushpin', 'thumbtack'],
  'pin-outline': ['pushpin', 'thumbtack'],
  'pine-tree': ['christmas tree'],
  'pine-tree-box': ['forest'],
  pinwheel: ['windmill'],
  'pinwheel-outline': ['windmill'],
  play: ['triangle', 'start'],
  'play-circle': ['triangle', 'start'],
  'playlist-check': ['checklist', 'todo', 'list'],
  podium: ['first place', 'stars'],
  'podium-bronze': ['third place'],
  'podium-gold': ['first place'],
  'podium-silver': ['second place'],
  poll: ['graph', 'vote'],
  popcorn: ['movie', 'snack'],
  'pot-mix': ['mortar', 'pestle', 'mixing'],
  'power-sleep': ['moon', 'night'],
  prescription: ['rx', 'medicine'],
  presentation: ['easel', 'board', 'whiteboard'],
  'presentation-play': ['easel', 'board', 'whiteboard'],
  'progress-check': ['done'],
  'projector-screen': ['presentation', 'board', 'easel'],
  pulse: ['heartbeat'],
  pumpkin: ['halloween'],
  puzzle: ['piece'],
  'puzzle-outline': ['piece'],
  racquetball: ['racket'],
  'radio-tower': ['antenna', 'broadcast'],
  'radiobox-blank': ['circle'],
  record: ['dot', 'circle'],
  'record-player': ['turntable'],
  refresh: ['reload'],
  reminder: ['finger', 'string'],
  repeat: ['loop'],
  restore: ['undo'],
  ribbon: ['awareness'],
  rice: ['bowl', 'chopsticks'],
  ring: ['wedding', 'jewelry', 'diamond'],
  'road-variant': ['highway'],
  'roller-skate': ['skating'],
  rollerblade: ['skating'],
  'room-service': ['cloche', 'dinner'],
  'room-service-outline': ['cloche', 'dinner'],
  routes: ['signpost', 'directions'],
  rowing: ['boat'],
  ruler: ['measure', 'measuring'],
  'ruler-square': ['measure', 'measuring'],
  run: ['running', 'runner'],
  'run-fast': ['running', 'speed'],
  sack: ['bag', 'money bag'],
  sale: ['badge'],
  saxophone: ['instrument'],
  scale: ['weighing'],
  'scale-bathroom': ['weight'],
  school: ['mortarboard'],
  script: ['paper'],
  'script-outline': ['paper'],
  'script-text': ['paper'],
  'script-text-outline': ['paper'],
  seal: ['badge', 'rosette'],
  'search-web': ['magnifying glass'],
  'set-all': ['venn diagram', 'circles'],
  'set-center': ['venn diagram', 'circles'],
  'set-center-right': ['venn diagram', 'circles'],
  'set-left': ['venn diagram', 'circles'],
  'set-left-center': ['venn diagram', 'circles'],
  'set-left-right': ['venn diagram', 'circles'],
  'set-none': ['circles'],
  'set-right': ['venn diagram', 'circles'],
  shape: ['triangle', 'square', 'circle', 'shapes'],
  'shape-outline': ['triangle', 'square', 'circle', 'shapes'],
  'shape-plus': ['triangle', 'square', 'circle', 'shapes'],
  sheep: ['lamb', 'wool'],
  'ship-wheel': ['steering wheel', 'sailing'],
  'shoe-heel': ['high heel'],
  'shoe-print': ['steps', 'walking'],
  shopping: ['bag'],
  shovel: ['spade', 'dig'],
  shuffle: ['random'],
  'sign-caution': ['roadwork', 'construction'],
  'sign-direction': ['signpost', 'directions'],
  'sign-text': ['board'],
  'signature-freehand': ['autograph'],
  silverware: ['spoon', 'fork', 'knife', 'eat'],
  'silverware-fork-knife': ['eat'],
  'silverware-variant': ['eat'],
  sitemap: ['hierarchy', 'org chart'],
  skate: ['ice skating', 'skates'],
  sleep: ['zzz', 'tired'],
  snowflake: ['winter'],
  snowman: ['winter'],
  soccer: ['ball'],
  'solar-power': ['sun'],
  'sort-alphabetical': ['abc'],
  'space-invaders': ['alien', 'game'],
  speedometer: ['gauge'],
  spellcheck: ['spelling', 'abc'],
  'spider-web': ['halloween'],
  spotlight: ['light', 'stage'],
  spray: ['can'],
  stairs: ['steps', 'staircase'],
  'star-face': ['happy'],
  'star-four-points': ['sparkle'],
  'star-four-points-outline': ['sparkle'],
  steering: ['wheel', 'car', 'drive'],
  stethoscope: ['doctor'],
  'sticker-emoji': ['smiley', 'face'],
  stocking: ['christmas', 'sock'],
  stove: ['cooking'],
  subway: ['train'],
  'subway-variant': ['train'],
  summit: ['mountain', 'flag'],
  sunglasses: ['glasses'],
  swim: ['swimming', 'swimmer'],
  sync: ['refresh', 'cycle'],
  table: ['grid'],
  tablet: ['ipad'],
  'tag-faces': ['smiley'],
  target: ['crosshairs', 'aim'],
  taxi: ['car'],
  tea: ['cup', 'mug'],
  'tea-outline': ['cup', 'mug'],
  teach: ['presentation'],
  telescope: ['stars'],
  television: ['screen'],
  terrain: ['mountains', 'mountain'],
  'test-tube': ['chemistry'],
  theater: ['movie'],
  'thought-bubble': ['cloud'],
  'thought-bubble-outline': ['cloud'],
  tie: ['necktie'],
  timetable: ['schedule'],
  toolbox: ['kit'],
  'toolbox-outline': ['kit'],
  tooth: ['teeth'],
  'tooth-outline': ['teeth', 'dentist'],
  'tower-beach': ['lifeguard'],
  'tower-fire': ['lookout'],
  'traffic-light': ['stoplight'],
  translate: ['languages'],
  trophy: ['cup', 'award'],
  'trophy-award': ['star'],
  'trophy-outline': ['cup', 'award'],
  'trophy-variant': ['cup', 'award'],
  'trophy-variant-outline': ['cup', 'award'],
  'tshirt-crew': ['clothes'],
  'tshirt-crew-outline': ['clothes'],
  'tshirt-v': ['clothes'],
  tune: ['sliders', 'adjust'],
  turtle: ['tortoise'],
  umbrella: ['rain'],
  'umbrella-outline': ['rain'],
  undo: ['back'],
  update: ['refresh'],
  'van-passenger': ['minibus'],
  video: ['camera'],
  'video-vintage': ['film camera', 'movie camera'],
  violin: ['instrument', 'fiddle'],
  voice: ['person'],
  'volume-high': ['sound', 'loud'],
  vote: ['ballot box'],
  'vote-outline': ['ballot box'],
  walk: ['person', 'pedestrian'],
  wallet: ['money', 'purse'],
  'wallet-giftcard': ['present'],
  'wallet-travel': ['suitcase', 'luggage'],
  watch: ['wristwatch', 'time'],
  water: ['droplet', 'rain'],
  'water-outline': ['droplet', 'rain'],
  waves: ['sea'],
  'weather-hurricane': ['storm'],
  'weather-partlycloudy': ['sun'],
  'weather-sunset': ['sunrise'],
  'wheelchair-accessibility': ['disability'],
  'white-balance-incandescent': ['lightbulb', 'bulb', 'light'],
  'white-balance-iridescent': ['lamp', 'light', 'tube'],
  widgets: ['shapes'],
  'wind-turbine': ['windmill', 'energy'],
  worker: ['builder'],
  wrench: ['fix'],
  'wrench-outline': ['fix']
};
